/*
 * @Autor: GeekMzy
 * @Date: 2022-05-12 13:56:13
 * @LastEditors: GeekMzy
 * @LastEditTime: 2022-05-12 13:56:48
 * @FilePath: \htwlgs-drainage-webv2.2\src\config\Bus.js
 * @Author: desktop-1llkr2o
 */
import mitt from 'mitt'
const bus = mitt()
export default bus
